



























































import { Component, mixins } from '@niknevis/vue-modules'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Emit, Prop } from 'vue-property-decorator'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'

@Component({
  components: {
    BaseButton,
    Confirm
  }
})
export default class WarningConfirm extends mixins(DialogMixin) {
  visibility: boolean = false

  @Prop({ default: 'حذف' }) submitText!: string
  @Prop({ default: 'انصراف' }) cancelText!: string
  @Prop({ default: 'حذف اطلاعات' }) title!: string
  @Prop({ required: true }) message!: string

  get target() {
    return this.$refs.dialog.$refs.dialog
  }

  @Emit()
  submit() {
  }
}
